import React, { useEffect, useRef } from 'react';
import { Box, Paper, Typography, Divider } from '@mui/material';

const roleLabel = (role) =>
  role === 'therapist' ? 'You' :
  role === 'client'    ? 'Client' :
  'Speaker';

const roleColor = (role) =>
  role === 'therapist' ? 'primary.main' :
  role === 'client'    ? 'secondary.main' :
  'text.secondary';

export default function TranscriptPane({ messages }) {
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages.length]);

  return (
    <Paper
      elevation={1}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 420
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          Live transcript
        </Typography>
      </Box>
      <Divider />
      <Box
        ref={scrollRef}
        sx={{
          flex: 1,
          overflowY: 'auto',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 1.25
        }}
      >
        {messages.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            Waiting for speech...
          </Typography>
        )}
        {messages.map((m, i) => (
          <Box key={`${m.timestamp}-${i}`} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              variant="caption"
              sx={{ color: roleColor(m.speakerRole), fontWeight: 600 }}
            >
              {roleLabel(m.speakerRole)}
            </Typography>
            <Typography variant="body2">{m.text}</Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
